<template>
  <div class="support-box">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Support'
}
</script>
